import script from "./CreateNewFolderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewFolderModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewFolderModal.vue?vue&type=style&index=0&id=23464ea0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23464ea0"]])

export default __exports__